import React, {useContext} from 'react';
import axios from "axios";
import {prefixUrl} from "../../utils/utilsData";
import {toast} from "react-toastify";
import {SetPrintDataContext} from "../../Pages";
import {useNavigate} from "react-router-dom";

function OperatingColumn(props) {

  const cell = props.cell;
  const setprint = useContext(SetPrintDataContext);
  const navigateTo = useNavigate()
  const printHandler = async () => {
    const orderId = cell.getData().orderId;

    try {
      const toastId = toast.loading('در حال دریافت اطلاعات...')
      const url = prefixUrl() + '/cartTable/?request=cartPrint&orderId=' + orderId
      const response = await axios.get(url)
      toast.dismiss(toastId)
      if (response.data.status) {

        const sendData = {
          type: "ANIPO_Print4",
          ...response.data.data,
        };
        setprint(sendData);
        navigateTo("/factorprint");
      } else {
        toast.error(response.data.message)
      }


    } catch (e) {
      console.log(e)
    }


  }



  const ViewOrderHandler = ()=>{


    const orderId = cell.getData().orderId;
    if (orderId) {
      navigateTo('/OrdersSadan',{state: {id:orderId}})
    }
  }

  return (<div>
    {/*{JSON.stringify(cell.getData())}*/}


    <div className={"d-flex"}>
      <div
        className={"cursor__pointer"}
        onClick={printHandler}>
        <svg
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="printer 1">
            <path
              id="Vector"
              d="M13.9584 6.45866H6.04169C5.70002 6.45866 5.41669 6.17533 5.41669 5.83366V4.16699C5.41669 2.03366 6.40835 1.04199 8.54169 1.04199H11.4584C13.5917 1.04199 14.5834 2.03366 14.5834 4.16699V5.83366C14.5834 6.17533 14.3 6.45866 13.9584 6.45866ZM6.66669 5.20866H13.3334V4.16699C13.3334 2.75033 12.875 2.29199 11.4584 2.29199H8.54169C7.12502 2.29199 6.66669 2.75033 6.66669 4.16699V5.20866Z"
              fill="#B9B9B9"
            />
            <path
              id="Vector_2"
              d="M10.8334 18.9583H9.16669C7.15002 18.9583 6.04169 17.85 6.04169 15.8333V12.5C6.04169 12.1583 6.32502 11.875 6.66669 11.875H13.3334C13.675 11.875 13.9584 12.1583 13.9584 12.5V15.8333C13.9584 17.85 12.85 18.9583 10.8334 18.9583ZM7.29169 13.125V15.8333C7.29169 17.15 7.85002 17.7083 9.16669 17.7083H10.8334C12.15 17.7083 12.7084 17.15 12.7084 15.8333V13.125H7.29169Z"
              fill="#B9B9B9"
            />
            <path
              id="Vector_3"
              d="M15 15.6247H13.3333C12.9917 15.6247 12.7083 15.3413 12.7083 14.9997V13.1247H7.29167V14.9997C7.29167 15.3413 7.00833 15.6247 6.66667 15.6247H5C2.98333 15.6247 1.875 14.5163 1.875 12.4997V8.33301C1.875 6.31634 2.98333 5.20801 5 5.20801H15C17.0167 5.20801 18.125 6.31634 18.125 8.33301V12.4997C18.125 14.5163 17.0167 15.6247 15 15.6247ZM13.9583 14.3747H15C16.3167 14.3747 16.875 13.8163 16.875 12.4997V8.33301C16.875 7.01634 16.3167 6.45801 15 6.45801H5C3.68333 6.45801 3.125 7.01634 3.125 8.33301V12.4997C3.125 13.8163 3.68333 14.3747 5 14.3747H6.04167V12.4997C6.04167 12.158 6.325 11.8747 6.66667 11.8747H13.3333C13.675 11.8747 13.9583 12.158 13.9583 12.4997V14.3747Z"
              fill="#B9B9B9"
            />
            <path
              id="Vector_4"
              d="M14.1666 13.125H5.83331C5.49165 13.125 5.20831 12.8417 5.20831 12.5C5.20831 12.1583 5.49165 11.875 5.83331 11.875H14.1666C14.5083 11.875 14.7916 12.1583 14.7916 12.5C14.7916 12.8417 14.5083 13.125 14.1666 13.125Z"
              fill="#B9B9B9"
            />
            <path
              id="Vector_5"
              d="M8.33331 9.79199H5.83331C5.49165 9.79199 5.20831 9.50866 5.20831 9.16699C5.20831 8.82533 5.49165 8.54199 5.83331 8.54199H8.33331C8.67498 8.54199 8.95831 8.82533 8.95831 9.16699C8.95831 9.50866 8.67498 9.79199 8.33331 9.79199Z"
              fill="#B9B9B9"
            />
          </g>
        </svg>

      </div>
      <div
        className={"cursor__pointer mx-3"}
        onClick={ViewOrderHandler}
      >
        <svg
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="eye 1">
            <path
              id="Vector"
              d="M9.99992 13.6083C8.00827 13.6083 6.3916 11.9916 6.3916 9.99992C6.3916 8.00827 8.00827 6.3916 9.99992 6.3916C11.9916 6.3916 13.6083 8.00827 13.6083 9.99992C13.6083 11.9916 11.9916 13.6083 9.99992 13.6083ZM9.99992 7.6416C8.69992 7.6416 7.6416 8.69992 7.6416 9.99992C7.6416 11.2999 8.69992 12.3583 9.99992 12.3583C11.2999 12.3583 12.3583 11.2999 12.3583 9.99992C12.3583 8.69992 11.2999 7.6416 9.99992 7.6416Z"
              fill="#B9B9B9"
            />
            <path
              id="Vector_2"
              d="M10.0001 17.5167C6.86675 17.5167 3.90842 15.6834 1.87509 12.5001C0.991752 11.1251 0.991752 8.88341 1.87509 7.50006C3.91675 4.31673 6.87509 2.4834 10.0001 2.4834C13.1251 2.4834 16.0834 4.31673 18.1168 7.50006C19.0001 8.87508 19.0001 11.1167 18.1168 12.5001C16.0834 15.6834 13.1251 17.5167 10.0001 17.5167ZM10.0001 3.7334C7.30842 3.7334 4.73342 5.35007 2.93342 8.17507C2.30842 9.15008 2.30842 10.8501 2.93342 11.8251C4.73342 14.6501 7.30842 16.2667 10.0001 16.2667C12.6918 16.2667 15.2668 14.6501 17.0668 11.8251C17.6918 10.8501 17.6918 9.15008 17.0668 8.17507C15.2668 5.35007 12.6918 3.7334 10.0001 3.7334Z"
              fill="#B9B9B9"
            />
          </g>
        </svg>

      </div>


    </div>
  </div>);
}

export default OperatingColumn;